import React from 'react';
import { useTheme } from '../App';
const AskAgentBlaze = () => {
  const {
    isDarkMode
  } = useTheme();
  return <div className={`rounded-lg overflow-hidden ${isDarkMode ? 'bg-[#161b22]' : 'bg-[#f0f5f3]'} border ${isDarkMode ? 'border-[#30363d]' : 'border-gray-200'}`} data-id="element-70">
      <div className={`p-4 ${isDarkMode ? 'bg-[#161b22]' : 'bg-[#f0f5f3]'}`} data-id="element-71">
        <div className="flex items-center" data-id="element-72">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4N2H7BgB83ACFYdnssfkby/Agent_BLAZE_logo_only_1757948635737.png" alt="Agent BLAZE icon" className="w-6 h-6 mr-2" data-id="element-73" />
          <div data-id="element-74">
            <h2 className="text-xl font-bold" data-id="element-75">Ask Agent BLAZE</h2>
            <p className="text-sm text-gray-400" data-id="element-76">
              Chat with your AI ops partner—ask, analyze, and run plays
            </p>
          </div>
        </div>
      </div>
      <div className={`p-4 ${isDarkMode ? 'bg-[#0d1117]' : 'bg-white'} h-[400px] flex items-center justify-center`} data-id="element-77">
        {/* Empty content for Phase 1 */}
      </div>
    </div>;
};
export default AskAgentBlaze;